/**
 * @import { ItineraryDay } from '@/features/itinerary-map/types/itinerary-day'
 */

import { LegendControl } from '@/ui/legend-control/legend-control';
import { useCruiseWithRoute } from '../../hooks/use-cruise';
import { routeCategory } from '../path-layer';
import { PortSymbol } from '../ports-layer';
import classes from './legend.module.css';
import { Line } from './line';

/**
 * @param {object} props
 * @param {ItineraryDay[]} [props.days]
 * @returns {React.JSX.Element}
 */
export function Legend({ days }) {
  const data = useCruiseWithRoute();
  const routeCategories = new Set(data?.paths.features.map(({ properties }) => properties?.category) ?? []);
  const hasCruise = routeCategories.has(routeCategory.river) || routeCategories.has(routeCategory.ocean);
  const hasFlight = routeCategories.has(routeCategory.airplane);
  const hasExample = routeCategories.has(routeCategory.example);
  const hasOvernight = days?.some((day) => day.port.overnight);

  return (
    <LegendControl>
      {hasCruise && (
        <>
          <div>
            <Line stroke="var(--viking-red)" />
          </div>
          <div>Route</div>
        </>
      )}
      {hasFlight && (
        <>
          <div>
            <Line stroke="var(--viking-sky-blue)" />
          </div>
          <div>Chartered Flight</div>
        </>
      )}
      {hasExample && (
        <>
          <div>
            <Line stroke="var(--viking-red)" className={classes.dashed} />
          </div>
          <div>Example expedition destinations</div>
        </>
      )}
      <div className={classes.current}>
        <PortSymbol isCurrent={true} />
      </div>
      <div>Selected Day</div>
      {hasOvernight && (
        <>
          <div className={classes.overnight}>
            <PortSymbol isOvernight={true} />
          </div>
          <div>Overnight in Port</div>
        </>
      )}
      <div className={classes.port}>
        <PortSymbol />
      </div>
      <div>Itinerary Port</div>

      <div className={classes.pin}>
        <PortSymbol isStart={true} />
      </div>
      <div>Itinerary Start</div>
    </LegendControl>
  );
}
